import styled from 'styled-components';
import { Copyright } from '../atoms/Copyright/Copyright';
import { SocialLinks } from '../atoms/SocialLinks/SocialLinks';

const FooterContainer = styled.footer`
  width: 100%;
  background: #333;
  padding: 2rem 0;
  box-shadow: 0 -5px 15px rgba(0, 0, 0, 0.65);
  margin-top: 2rem;

  @media (max-width: 768px) {
    padding: 2rem 0 4rem 0; 
  }
`;


const FooterContent = styled.div`
  margin: 0 auto;
  max-width: 1200px;
  width: 100%;
  padding: 0 4rem;

  @media (max-width: 1200px) { padding: 0 2.5rem; }
  @media (max-width: 992px) { padding: 0 1.25rem; }
  @media (max-width: 768px) { padding: 0 1rem; }
  @media (max-width: 576px) { padding: 0 0.75rem; }
`;

export const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <SocialLinks />
        <Copyright />
      </FooterContent>
    </FooterContainer>
  );
};